// extracted by mini-css-extract-plugin
export var layoutContainer = "_e1-0";
export var layoutContainerNoRounding = "_e1-6";
export var layoutContainerOpen = "_e1-5";
export var layoutContainerResizing = "_e1-1";
export var mainContent = "_e1-2";
export var resizeDivider = "_e1-3";
export var slidePanel = "_e1-4";